// Helpers purs pour la hiérarchie des groupes de produits (parent / sous-groupes)

export function isRootGroup(group, rootValue = 0) {
  const p = group.parentGroupId;
  return p === null || p === undefined || p === '' || String(p) === String(rootValue);
}

// enfants indexés par parentGroupId
export function buildChildrenMap(groups) {
  const map = {};
  (groups || []).forEach(g => {
    if (!isRootGroup(g)) {
      const key = String(g.parentGroupId);
      (map[key] = map[key] || []).push(g);
    }
  });
  return map;
}

export function childCountOf(childrenMap, productGroupId) {
  return (childrenMap[String(productGroupId)] || []).length;
}

// groupes éligibles comme sous-groupe : racines, sans enfants, hors le parent courant
export function eligibleSubgroups(groups, parentId, childrenMap) {
  return (groups || []).filter(g =>
      isRootGroup(g) &&
      String(g.productGroupId) !== String(parentId) &&
      childCountOf(childrenMap, g.productGroupId) === 0
  );
}
